export default __webpack_public_path__ + "static/media/slider2.a6f5a71e.jpeg";